'use client';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import errorImg from '../img/error-img.png';
import './index.scss';

function Index({ src }: { src: string }) {
  const [isLoading, setIsLoading] = useState(true);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!src) {
      setShowError(true);
    }
  }, [src]);

  const handleImgLoad = () => {
    setIsLoading(false);
    setShowError(false);
  };
  const handleImgError = () => {
    setIsLoading(false);
    setShowError(true);
  };

  return (
    <div className='img-container'>
      {!showError && (
        <div className='successImg'>
          <img src={src} onLoad={handleImgLoad} onError={handleImgError} />
        </div>
      )}
      {isLoading && (
        <div className='loadingImg'>
          <Image src={errorImg} alt='loadingImg' />
        </div>
      )}
      {showError && (
        <div className='errorImg'>
          <Image src={errorImg} alt='errorImg' />
        </div>
      )}
    </div>
  );
}

export default Index;
